import React from "react";

import { TrashIcon } from "@/assets/icons";

import { ActionButton } from "./ActionButton";

interface DeleteActionProps {
  disabled?: boolean;
  label?: string;
  onDelete: () => void;
}
export const DeleteAction = (props: DeleteActionProps) => {
  return (
    <ActionButton
      aria-label={props.label || "Delete"}
      title={props.label || "Delete"}
      onClick={props.onDelete}
      disabled={props.disabled}
    >
      <TrashIcon />
    </ActionButton>
  );
};
